import { Link, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const TermsLinks = () => {
	const { translate } = useLocales();

	return (
		<Typography align='center' sx={{ color: "text.secondary", mt: 3 }} variant='body2'>
			<Link
				color='text.secondary'
				href='https://www.vumi.io/terminos-y-condiciones'
				target={"_blank"}
			>
				{translate("login.terms")}
			</Link>
			<Link
				color='text.secondary'
				href='https://www.vumi.io/politica-de-privacidad/'
				sx={{ ml: 2 }}
				target={"_blank"}
			>
				{translate("login.privacy_policy")}
			</Link>
			.
		</Typography>
	);
};

export default TermsLinks;
